import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

export let startSymphonyServices = data => {
  ReactDOM.render(
    <App
      assessmentDelivery={Boolean(data.assessment_delivery)}
      symphonyData={data.symphony_data}
    />,
    document.getElementById('symphony_services')
  )
}
